import { useOnMount } from '@hooks';

import React, { PropsWithChildren, useState } from 'react';

export interface DeferredRenderProps {
	delay: number;
}

export const DeferredRender: React.FC<PropsWithChildren<DeferredRenderProps>> = ({ children, delay }) => {
	const [ isReady, setIsReady ] = useState(false);

	useOnMount(() => {
		setTimeout(() => setIsReady(true), delay);
	});

	return isReady ? children : null;
};
